var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MemberRole } from '@lucidlink/dto/validation';
import { Strong, Trans, translate } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
import { getUserRoleMap } from '#services';
const RegularRoleChangeModalDescription = ({ role, roleTranslationMap, workspaceName, }) => (_jsxs(Trans, { values: {
        workspaceName,
        role: roleTranslationMap[role === MemberRole.COLLABORATOR ? 'STANDARD_USER' : role],
    }, children: ["Your role in the", ' ', _jsx(Strong, { className: PII_MASK_CLASS, color: "accent", children: '{{workspaceName}}' }), ' ', "workspace has been changed to", ' ', _jsx(Strong, { color: "accent", children: '{{role}}' }), "."] }));
_react_refresh_temp_1 = RegularRoleChangeModalDescription;
$RefreshReg$(_react_refresh_temp_1, "RegularRoleChangeModalDescription");
const getFilespaceAdminPermissionChangeContent = ({ demotedFsIds, grantedFsIds, roleTranslationMap, workspaceName, }) => {
    const grantedContent = grantedFsIds.length
        ? grantedFsIds.length === 1
            ? translate('You have been granted full access and permissions to manage {{filespaceCount}} new filespace.', { filespaceCount: grantedFsIds.length })
            : translate('You have been granted full access and permissions to manage {{filespaceCount}} new filespaces.', { filespaceCount: grantedFsIds.length })
        : null;
    const demotedContent = demotedFsIds.length
        ? demotedFsIds.length === 1
            ? translate('Your permissions for {{filespaceCount}} filespace have been revoked.', { filespaceCount: demotedFsIds.length })
            : translate('Your permissions for {{filespaceCount}} filespaces have been revoked.', { filespaceCount: demotedFsIds.length })
        : null;
    return {
        modalDescriptionText: (_jsxs(Trans, { values: {
                workspaceName,
                role: roleTranslationMap[MemberRole.FILESPACE_ADMIN],
            }, children: ["Your permissions for your", ' ', _jsx(Strong, { color: "accent", children: '{{role}}' }), " role in the", ' ', _jsx(Strong, { className: PII_MASK_CLASS, color: "accent", children: '{{workspaceName}}' }), ' ', "workspace have been changed."] })),
        modalRoleInfo: null,
        modalRoleInfoDescription: (_jsxs(_Fragment, { children: [grantedContent, " ", demotedContent] })),
    };
};
export const getRoleChangeModalContent = ({ demotedFsIds, grantedFsIds, prevRole, role, workspaceName, }) => {
    const roleChangeKey = `${prevRole}_TO_${role}`;
    const roleTranslationMap = getUserRoleMap();
    const modalDescriptionText = (_jsx(RegularRoleChangeModalDescription, { role: role, roleTranslationMap: roleTranslationMap, workspaceName: workspaceName }));
    const limitedPermissionsContent = (_jsx(Trans, { children: "Some features you previously had access to may now be limited. If you need additional permissions, please contact your workspace administrator." }));
    switch (roleChangeKey) {
        case `${MemberRole.COLLABORATOR}_TO_${MemberRole.ADMIN}`:
            return {
                modalDescriptionText,
                modalRoleInfo: (_jsx(Trans, { children: "You now have access to workspace management features, including settings, permissions, and team members." })),
            };
        case `${MemberRole.ADMIN}_TO_${MemberRole.COLLABORATOR}`:
            return {
                modalDescriptionText,
                modalRoleInfo: limitedPermissionsContent,
            };
        case `${MemberRole.COLLABORATOR}_TO_${MemberRole.FILESPACE_ADMIN}`:
            return {
                modalDescriptionText,
                modalRoleInfo: (_jsx(Trans, { children: "You now have access to workspace management features, including settings, permissions, and team members." })),
            };
        case `${MemberRole.FILESPACE_ADMIN}_TO_${MemberRole.COLLABORATOR}`:
            return {
                modalDescriptionText,
                modalRoleInfo: limitedPermissionsContent,
            };
        case `${MemberRole.ADMIN}_TO_${MemberRole.FILESPACE_ADMIN}`:
            return {
                modalDescriptionText,
                modalRoleInfo: limitedPermissionsContent,
            };
        case `${MemberRole.FILESPACE_ADMIN}_TO_${MemberRole.ADMIN}`:
            return {
                modalDescriptionText,
                modalRoleInfo: (_jsx(Trans, { children: "You have been granted full access and permissions to manage filespaces and users." })),
            };
        case `${MemberRole.FILESPACE_ADMIN}_TO_${MemberRole.FILESPACE_ADMIN}`:
            return getFilespaceAdminPermissionChangeContent({
                workspaceName,
                role,
                demotedFsIds,
                grantedFsIds,
                roleTranslationMap,
            });
        default:
            // eslint-disable-next-line no-console -- report for unhandled role change attempt
            console.warn(`Unhandled role combination ${roleChangeKey}!`);
            return {
                modalDescriptionText: null,
                modalRoleInfo: null,
                modalRoleInfoDescription: null,
            };
    }
};
